<template>
    <div>
        <v-text-field dense label="Question" outlined v-model="question" :value="field.question" @keyup="emitChange()"></v-text-field>

        <v-text-field v-for="(a,k) in answer"
                      :key="k" prepend-icon="mdi-checkbox-blank-circle-outline"
                      dense
                      :label="`Answer ${k.toUpperCase()}`"
                      outlined
                      v-model="answer[k]"
                      @keyup="emitChange()"></v-text-field>
         <!--<v-radio-group dense v-model="radiogroup">-->
            <!--<v-radio :label="`${answer.a}`" value="a"></v-radio>-->
            <!--<v-radio :label="`${answer.b}`" value="b"></v-radio>-->
            <!--<v-radio :label="`${answer.c}`" value="c"></v-radio>-->
            <!--<v-radio :label="`${answer.d}`" value="d"></v-radio>-->
        <!--</v-radio-group>-->
    </div>
</template>

<script>
  export default {
    props:['field'],
    components: {},
    name: "MultipleChoice",
    data() {
      return {
        radiogroup: undefined,
        question: undefined,
        index:0,
        options:['a','b','c','d','e','f','g','h','i','j','k']
      }
    },
    computed:{
      answer(){
        return this.field.answer || {a:'',b:'',c:'',d:''}
      }
    },
    mounted() {
    },
    methods: {
      emitChange(){
        this.$emit('formData',{question: this.question, answer: this.answer})
      },
      setAnswers(count){

      }
    }
  }
</script>

<style scoped>

</style>